<template>
  <div>
    <list-table
      :url="url"
      title="گردش حساب"
      :fields="fields"
      :params="params"
      @updateListResult="updateListResult"
    ></list-table>
  </div>
</template>
<script>
import { SET_BREADCRUMB } from "@/core/services/store/breadcrumbs.module";
import {
  GET_MOEIN,
  GET_COMPRATIVE,
} from "@/core/services/store/AccounType.module";
import TableShowData from "../../components/table";

export default {
  name: "turnOver",
  data() {
    return {
      url: "acc-doc-detail/turn-over",
      val1: null,
      val2: null,
      params: [
        {
          label: "معین",
          field: "topic_id",
          type: "vselect",
          text: "بانک",
          value: 5,
          options: [],
        },

        {
          label: "تفضیلی",
          field: "detail_id",
          type: "vselectSearch",
          text: "بانک سامان به شماره شبا IR670560952204003572578001 برای تسهیم",
          value: 1543,
          options: [],
        },
      ],
      fields: [
        {
          key: "doc_id",
          label: "کد سند",
        },
        {
          key: "id",
          label: "کد تفضیلی",
        },
        {
          key: "des",
          label: "توضیحات",
        },

        {
          key: "bes",
          label: "برداشت",
          formatter(value, key, item) {
            return Number(value).toLocaleString();
          },
        },
        {
          key: "bed",
          label: "واریز",
          formatter(value, key, item) {
            return Number(value).toLocaleString();
          },
        },
        {
          key: "totalsum",
          label: "مجموع",
          formatter(value, key, item) {
            return Number(value).toLocaleString();
          },
        },
      ],
      // detailUrl:"SharingDetails",
    };
  },
  components: {
    "list-table": TableShowData,
  },
  computed: {
    loadedComparative() {
      return this.$store.getters.loadedComparative;
    },
    loadedMoein() {
      return this.$store.getters.loadedMoein;
    },
  },
  methods: {
    updateListResult(value){
      this.acctopicRequest(value)
    },
    acctopicRequest(name){
      this.params[1].options = []
      this.$store.dispatch(GET_COMPRATIVE, "accdetailall?name=" + name).then((data) => {
      data.result.forEach((element) => {
        let opt = {};
        this.params[1].options.push(
          Object.assign(opt, { text: element.name, value: element.id })
        );
      });
    });
    }
  },
  created() {},
  mounted() {
    this.$store.dispatch(SET_BREADCRUMB, [{ title: "لیست تسویه های تسهیم" }]);
    this.$store.dispatch(GET_MOEIN, "acctopic").then((data) => {
      data.result.forEach((element) => {
        let opt = {};
        this.params[0].options.push(
          Object.assign(opt, { text: element.name, value: element.id })
        );
      });
    });
    this.acctopicRequest('')
  },
};
</script>